import axios from 'axios';
import { userToken, clearSession } from 'src/services/Users';
import { refreshNavigation } from 'src/components/AppSidebar';

const LOGIN_ROUTE = '#/';

class Auth {
  // SECURITY FIX: Removed client-side "encryption" which was not secure
  // Password security is provided by HTTPS transport layer
  // The server should handle password hashing with bcrypt

  // SECURITY: returns the JWT stored at login — no network call. The old POST /users/token
  // (token for any email, no password) was removed server-side. Return shape kept for the
  // existing API/* call sites; the email argument they pass is ignored.
  async getToken() {
    const token = userToken();
    if (!token) {
      this.logout();
      return { object: 'error', msg: 'Session expired, please log in again' };
    }
    return { object: 'success', msg: 'Success...', data: token };
  }

  async login(inputPost) {
    // SECURITY: Send password in plain text over HTTPS
    // The server is responsible for secure password handling
    try {
      const resp = await axios.post(`${process.env.REACT_APP_BACKEND}/users/login`, {
        email: inputPost.email,
        password: inputPost.password
      }, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (resp.status !== 200) return { object: 'error', msg: resp.data?.success?.message || 'Server error' };
      else {
        if (!resp.data?.success?.state) return { object: 'error', msg: resp.data?.success?.message || 'Login failed' };
        if (!resp.data.success.token) return { object: 'error', msg: 'Login failed: no session token' };
        localStorage.setItem('user', JSON.stringify(resp.data.success.rows));
        localStorage.setItem('token', resp.data.success.token);
        // Refresh navigation after login to show correct menu based on role
        refreshNavigation();
        return { object: resp.data.name, msg: resp.data.success };
      }
    } catch (error) {
      return { object: 'error', msg: error.message }
    }
  }

  logout() {
    clearSession();
    window.location = LOGIN_ROUTE;
  }

  // Expired/invalid token or deactivated account → back to login. Installed once in index.js.
  installInterceptor() {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isLoginCall = error?.config?.url?.endsWith('/users/login');
        if (error?.response?.status === 401 && !isLoginCall) this.logout();
        return Promise.reject(error);
      },
    );
  }

  getHeader(token) {
    return {
      'Content-Type': 'application/json',
      'Authorization': `BZREALTIME ${token}`
    }
  }
}
export default new Auth();
